<template>
  <div id="app" class="row vert-offset-top-1">
    <div class="row justify-content-center">
      <div class="col s12 m10 l8 offset-m1 offset-l2">
        <div id="card" class="card col s12 vert-offset-top-1 z-depth-3">
          <div
            class="card-title center padding-top-half padding-bottom-half border-bottom-1 grey-border border-lighten-2"
          >
            <h5 class="grey-text text-darken-2">
              Enter your Contact Details
            </h5>
          </div>
          <div class="card-content col s12">
            <div class="col s12 m10 offset-m1 padding-top-half">
              <div
                class="col s3 m2 l1 vert-offset-top-1 font-16 right-align font-bold"
              >
                +267
              </div>
              <div class="col s9 m10 l11">
                <InputComponent
                  v-model="stateSelectedMobile"
                  type="tel"
                  label="Contact Number"
                  class="validate"
                  required="required"
                  :disabled="true"
                ></InputComponent>
              </div>
            </div>
            <div
              class="col s12 m10 offset-m1 padding-top-half padding-bottom-half"
            >
              <custom-select-component
                :options="countries"
                title="Type to Select your Nationality"
                v-model="selected_nationality_key"
                ref="obj_select_district"
                >{{ nationality }}</custom-select-component
              >
            </div>
            <div class="col s12 m10 offset-m1 padding-top-half">
              <InputComponent
                v-model="fullname"
                type="text"
                label="Full Name"
                required="required"
                >{{ fullname }}</InputComponent
              >
            </div>
            <div class="col s12 m10 offset-m1 padding-top-half">
              <div class="col s12 left-align">
                Date Of Birth
              </div>
              <date-pick
                class="col s12"
                v-model="dob"
                :selectableYearRange="{from: 1925, to: 2010}"
                @click.prevent="year()"
              ></date-pick>
            </div>
            <div class="col s12 m10 offset-m1 padding-top-half">
              <InputComponent
                v-model="idnumber"
                type="text"
                label="ID/Passport Number"
                required="required"
                >{{ idnumber }}</InputComponent
              >
            </div>

            <div class="col s12 m10 offset-m1 padding-top-half">
              <InputComponent
                v-model="email"
                type="email"
                id="email"
                label="E-Mail Address"
                class="validate"
                required="required"
                autofocus
                >{{ email }}</InputComponent
              >
            </div>
            <div
              class="col s12 m10 offset-m1 padding-top-half left-align no-padding"
            >
              <div class="col s12">
                <h6>Gender</h6>
              </div>
              <div class="col s6">
                <p v-for="(item, index) in genders"
                   :key="index">
                  <label>
                    <input type="radio" :value="item.value"
                           :key="index" @click="selectGender(index)"
                           name="Gender"
                           class="with-gap"
                    />
                    <span v-html="item.title" class="bold black-text"></span>
                  </label>
                </p>
              </div>
            </div>
            <div
                    class="col s12 m10 offset-m1 padding-top-half left-align no-padding"
            >
              <div class="col s12">
                <h6>Sexual Orientation</h6>
              </div>
              <div class="col s4">
                <p v-for="(item, index) in sexual_orientations"
                   :key="index">
                  <label>
                    <input type="radio" :value="item.key"
                           :key="index" @click="selectSexualOrientation(index)"
                           class="with-gap"
                           name="Sexual Orientation"
                    />
                    <span v-html="item.title" class="bold black-text"></span>
                  </label>
                </p>
              </div>

            </div>

            <div class="col s12 vert-offset-top-1">
              <div class="col s4">
                <a
                  @click.prevent="gobackto"
                  class="btn btn-small btn-block orange darken-1  white-text"
                >
                  back
                </a>
              </div>

              <div class="col s4 offset-s4">
                <a
                  @click.prevent="goto"
                  class="btn btn-small btn-block orange darken-1  white-text"
                  :disabled="!isValidForm"
                >
                  Continue
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputComponent from "@/components/materiallize/InputComponent";
import CustomSelectComponent from "../components/materiallize/CustomSelectComponent";
import { mapGetters } from "vuex";
import { mapState } from "vuex";
//import Datepicker from 'vuejs-datepicker';
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
//import SelectComponent from "@/components/materiallize/SelectComponent";
import moment from "moment";
import http from "../http-common";

export default {
  name: "UserDetails",
  components: {
   // SelectComponent,
      DatePick,
     // Datepicker,
   // VueCtkDateTimePicker,
    CustomSelectComponent,
    InputComponent
  },
  data() {
    return {
      districts: [],
      nationality: "",
      countries: [],
      genders:[],
      format: 'd MMMM yyyy',
      selected_gender:null,
      sexual_orientations:[],
      selected_sexual_orientation:null,
      email: "",
      fullname: "",
      idnumber: "",
      mobile: "",
      counter: 0,
      sexual_orientation:"",
      selected_item: [],
      selected_orientation: [],
      selected_nationality: null,
      selected_nationality_key: "",
      date:"",
      dob: "",
        yob:null
    };
  },
  methods: {
    goto() {
      this.$store.dispatch("SET_NATIONALITY", this.selected_nationality);
      this.$store.dispatch("SET_NAME", this.fullname);
      this.$store.dispatch("SET_ID", this.idnumber);
      this.$store.dispatch("SET_EMAIL", this.email);
      this.$store.dispatch("SET_GENDER", this.selected_gender);
      this.$store.dispatch("SET_DOB", this.dob);
        this.$store.dispatch("SET_YOB", this.selected_year);
      this.$store.dispatch(
        "SET_SEXUAL_ORIENTATION",
        this.selected_sexual_orientation
      );

      this.$router.push("/book");
    },
    getCountry() {
      return new Promise(resolve => {
        http({
          url: "api/list/nationality",
          data: {},
          method: "POST",
          timeout: 30000
        })
          .then(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.countries = response.data.data;
            resolve(response);
          })
          .catch(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.$store.dispatch("GET_MESSAGES", response.data.message);
            resolve(response);
          });
      });
    },
      customFormatter(date) {
          return moment(date).format(' YYYY d MM ');
      },
    getSexualOrientation() {
      return new Promise(resolve => {
        http({
          url: "api/list/sexualorientation",
          method: "POST",
          timeout: 30000
        })
                .then(response => {
                  this.$store.dispatch("STOP_PROCESSING");
                  this.sexual_orientations = response.data.data;
                  resolve(response);
                })
                .catch(response => {
                  this.$store.dispatch("STOP_PROCESSING");
                  this.$store.dispatch("GET_MESSAGES", response.data.message);
                  resolve(response);
                });
      });
    },
    getGender() {
      return new Promise(resolve => {
        http({
          url: "api/list/gender",
          method: "POST",
          timeout: 30000
        })
                .then(response => {
                  this.$store.dispatch("STOP_PROCESSING");
                  this.genders = response.data.data;
                  resolve(response);
                })
                .catch(response => {
                  this.$store.dispatch("STOP_PROCESSING");
                  this.$store.dispatch("GET_MESSAGES", response.data.message);
                  resolve(response);
                });
      });
    },

    gobackto() {
      this.$router.push("/usercontactdetails");
    },
    selectGender: function (_index)
    {
        this.selected_gender = this.genders[_index];
        window.console.log("SELECT GENDER: "+JSON.stringify(this.selected_gender));

    },

    selectSexualOrientation: function (_index)
    {
     this.selected_sexual_orientation = this.sexual_orientations[_index];

    },
    select_orientation: function(_index) {
      var _selected_orientation = this.sexual_orientation[_index];
      if (typeof _selected_orientation === "undefined" || _selected_orientation === null) {
        return false;
      }

      this.selected_orientation = _selected_orientation;
      this.counter++;
    },
    mustRedirectHome: function() {
      if (
        !this
          .stateHasSelectedCenter /*|| !this.stateHasSelectedDistrict*/ /*|| ! this.stateHasSelectedLocation*/ ||
        !this.stateHasSelectedMobile ||
        !this.stateHasSelectedDate ||
        !this.stateHasSelectedServices
      ) {
        return true;
      }
      return false;
    }
  },
  computed: {
    ...mapGetters({
      yearofbirth: "year_of_birth"
    }),
    ...mapState({
      stateSelectedMobile: state => state.mobile,
      stateSelectedFullName: state => state.name,
      stateSelectedIdNumber: state => state.id,
      stateSelectedEmail: state => state.email,
      stateSelectedDob: state => state.dob,
        stateSelectedYob: state => state.yob,
      stateSelectedSexualOrientation: state => state.sexual_orientation,
      stateSelectedGender: state => state.gender,
      stateSelectedDistrict: state => state.selectedDistrict,
      stateSelectedCenter: state => state.selectedCenter,
      stateSelectedLocation: state => state.selectedLocation,
      stateSelectedNationality: state => state.selectedNationality,
      stateSelectedServices: state => state.selectedServices,
      stateSelectedDate: state => state.date
    }),
    stateHasSelectedNationality: function() {
      return (
        typeof this.stateSelectedNationality !== "undefined" &&
        this.stateSelectedNationality !== null
      );
    },
    stateHasSelectedFullName: function() {
      return (
        typeof this.stateSelectedFullName !== "undefined" &&
        this.stateSelectedFullName !== null
      );
    },
    stateHasSelectedEmail: function() {
      return (
        typeof this.stateSelectedEmail !== "undefined" &&
        this.stateSelectedEmail !== null
      );
    },
    stateHasSelectedIdNumber: function() {
      return (
        typeof this.stateSelectedIdNumber !== "undefined" &&
        this.stateSelectedIdNumber !== null
      );
    },
    stateHasSelectedGender: function() {
      return (
        typeof this.stateSelectedGender !== "undefined" &&
        this.stateSelectedGender !== null
      );
    },
    stateHasSelectedSexualOrientation: function() {
      return (
              typeof this.stateSelectedSexualOrientation !== "undefined" &&
              this.stateSelectedSexualOrientation !== null
      );
    },
    stateHasSelectedDob: function() {
      return (
        typeof this.stateSelectedDob !== "undefined" &&
        this.stateSelectedDob !== null
      );
    },
      stateHasSelectedYob: function() {
          return (
              typeof this.stateSelectedYob !== "undefined" &&
              this.stateSelectedYob !== null
          );
      },
    stateHasSelectedDate: function() {
      return (
        typeof this.stateSelectedDate !== "undefined" &&
        this.stateSelectedDate !== null
      );
    },
    stateHasSelectedDistrict: function() {
      return (
        typeof this.stateSelectedDistrict !== "undefined" &&
        this.stateSelectedDistrict !== null
      );
    },
    stateHasSelectedLocation: function() {
      return (
        typeof this.stateSelectedLocation !== "undefined" &&
        this.stateSelectedLocation !== null
      );
    },
    stateHasSelectedCenter: function() {
      return (
        typeof this.stateSelectedCenter !== "undefined" &&
        this.stateSelectedCenter !== null
      );
    },
    stateHasSelectedMobile: function() {
      return (
        typeof this.stateSelectedMobile !== "undefined" &&
        this.stateSelectedMobile !== null
      );
    },
    stateHasSelectedServices: function() {
      return (
        typeof this.stateSelectedServices !== "undefined" &&
        this.stateSelectedServices !== null
      );
    },
    isValidName: function() {
      return (
        typeof this.fullname !== "undefined" &&
        this.fullname !== null &&
        this.fullname.length > 2 &&
        this.fullname.length <= 100
      );
    },
    isValidEmail: function() {
      return (
        typeof this.email !== "undefined" &&
        this.email !== null &&
        this.email.isValidateEmail() &&
        this.email.length <= 100
      );
    },
    isValidIdNumber: function() {
      return (
        typeof this.idnumber !== "undefined" &&
        this.idnumber !== null &&
        this.idnumber.length > 6 &&
        this.idnumber.length <= 32
      );
    },
    isValidGender: function() {
      return (
        typeof this.selected_gender !== "undefined" &&
        this.selected_gender !== null
      );
    },
    isValidDob: function() {
      return (
        typeof this.dob !== "undefined" &&
        this.dob !== null &&
        !isNaN(parseInt(this.dob)) &&
        parseInt(this.dob) > 1900 &&
        parseInt(this.dob) <= parseInt(moment().format("yyyy-M-dd"))
      );
    },
    isValidSexualOrientation: function() {
        return (
            typeof this.selected_sexual_orientation !== "undefined" &&
            this.selected_sexual_orientation !== null
        );
    },
    isValidForm: function() {
      return (
        this.isValidName &&
        this.isValidEmail &&
        this.isValidIdNumber &&
        this.isValidDob &&
        this.isValidGender &&
        this.isValidSexualOrientation
      );
    },
    checkboxinput(){
      return this.$store.state.genders;

    }
  },
  created() {
    this.getCountry();
    this.getSexualOrientation();
    this.getGender()

  },
  beforeCreate() {
    this.$store.commit("initialiseStore");
  },
  mounted() {
    if (this.mustRedirectHome()) {
      this.$router.push("/");
    }

    if (this.stateHasSelectedEmail) {
      this.email = this.stateSelectedEmail;
    }
    if (this.stateHasSelectedGender) {
      this.selected_gender = this.stateSelectedGender;
    }
    if (this.stateHasSelectedSexualOrientation) {
      this.selected_sexual_orientation = this.stateSelectedSexualOrientation;
    }
    if (this.stateHasSelectedDob) {
      this.dob = this.stateSelectedDob;
    }
      if (this.stateHasSelectedYob) {
          this.yob = this.stateSelectedYob;
      }
    if (this.stateHasSelectedIdNumber) {
      this.idnumber = this.stateSelectedIdNumber;
    }
    if (this.stateHasSelectedFullName) {
      this.name = this.stateSelectedFullName;
    }
    if (this.stateHasSelectedNationality) {
      this.name = this.stateSelectedNationality;
    }
  },
  watch: {
    selected_nationality_key: function(_value) {
      this.selected_nationality = null;

      if (typeof _value !== "undefined" && _value !== null) {
        var _arrFound = this.countries.filter(function(_item) {
          return _item.value === _value;
        });
        if (_arrFound.length > 0) {
          this.selected_nationality = _arrFound[0];
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
